import { defineStore } from 'pinia';
import { fetchFeatureFlags } from '@/app/shared/services/feature-service';
import { FEATURE_FLAGS } from '@/app/shared/constants/feature-flags';
import type { FeatureFlag } from '@/app/shared/types/feature-flag.type';
import { ref } from 'vue';

export const useFeatureStore = defineStore('featureStore', () => {
  const flags = ref<Record<FeatureFlag, boolean>>({
    [FEATURE_FLAGS.BATCH_AGENT]: true,
    [FEATURE_FLAGS.BATCH_LEGACY]: true,
    [FEATURE_FLAGS.BUREAU_COMPOSER]: true,
  });

  const initializeFeatureStore = async (): Promise<void> => {
    try {
      const data = await fetchFeatureFlags();
      Object.assign(flags.value, data);
    } catch (error) {
      console.error('Failed to fetch batch feature status', error);
    }
  };

  const isEnabled = (key: FeatureFlag): boolean => flags.value[key] ?? false;

  return {
    flags,
    initializeFeatureStore,
    isEnabled,
  };
});
